import { HttpHelper, HttpServiceParams } from 'rbh-merchant-core';
import { VAT_REQUEST_ID_LIST } from './vat-constant';
import { envConfig } from '../../../../config';

class VatServiceClass {
  getVat = async (params: HttpServiceParams) => {
    return await HttpHelper.get({
      url: envConfig.hostname + 'v1/merchant/company-admin/vat-addresses',
      id: VAT_REQUEST_ID_LIST.GET_VAT
    });
  }

  postVat = async (params: HttpServiceParams) => {
    return await HttpHelper.post({
      url: envConfig.hostname + 'v1/merchant/company-admin/vat-addresses',
      data: params.data,
      id: VAT_REQUEST_ID_LIST.POST_VAT
    });
  }

  patchVat = async (params: HttpServiceParams) => {
    return await HttpHelper.patch({
      url: envConfig.hostname + 'v1/merchant/company-admin/vat-addresses',
      data: params.data,
      id: VAT_REQUEST_ID_LIST.PATCH_VAT
    });
  }

  deleteVat = async (params: HttpServiceParams) => {
    return await HttpHelper.delete({
      url: envConfig.hostname + 'v1/merchant/company-admin/vat-addresses',
      config: { headers: { vatAddressId: params.data } },
      id: VAT_REQUEST_ID_LIST.DELETE_VAT
    });
  }

  patchVatDefault = async (params: HttpServiceParams) => {
    return await HttpHelper.patch({
      url: envConfig.hostname + 'v1/merchant/company-admin/vat-addresses/set-default',
      data: params.data,
      id: VAT_REQUEST_ID_LIST.PATCH_VAT_DEFAULT
    });
  }

  patchVatTaxes = async (params: HttpServiceParams) => {
    return await HttpHelper.patch({
      url: envConfig.hostname + 'v1/merchant/company-admin/vat-addresses/taxes',
      data: params.data,
      id: VAT_REQUEST_ID_LIST.PATCH_VAT_TAXES
    });
  }
}

export const VatService = new VatServiceClass();
